<template>
  <div class="flex flex-col md:flex-row gap-4">
    <el-select
      v-model="searchParams.company"
      :placeholder="$t('placeholder.searchCompany')"
      class="w-full"
      size="large"
      name="company"
      filterable
      data-cy="company"
      @change="selectCompany"
      :no-match-text="$t('message.noData')"
    >
      <el-option
        v-for="item in transform"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :title="item.label"
      />
    </el-select>
    <el-select
      v-model="searchParams.region"
      :placeholder="$t('placeholder.searchRegion')"
      class="w-full"
      size="large"
      name="region"
      filterable
      data-cy="region"
      @change="selectCompany"
      :no-match-text="$t('message.noData')"
    >
      <el-option
        v-for="item in regions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :title="item.label"
      />
    </el-select>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, onMounted, reactive, onBeforeMount, watch } from 'vue'
import { useStore } from 'vuex'
import { ROLE } from 'core/constants'

export default defineComponent({
  name: 'CompanySelectView',
  setup() {
    const store = useStore()
    const user = computed(() => store.getters['user/user'])
    const selectedCompany = computed(() => store.getters['division/selectCompany'])
    const searchParams = reactive({
      company: '',
      region: '',
    })

    const regions = computed(() =>
      store.getters['division/regions'].map((item: any) => ({
        value: item.code,
        label: item.name,
      })),
    )

    const companies = [
      { value: 'TCI', label: 'TCI' },
      { value: 'TCZ', label: 'TCZ' },
      { value: 'TTV', label: 'TTV' },
    ]

    const transform = computed(() => {
      if (user.value?.role !== ROLE.SUPER_ADMIN) {
        return companies.filter((c) => c.value === user.value?.company)
      }
      return companies
    })

    const selectCompany = () => {
      store.commit('division/SELECT_COMPANY', searchParams)
    }

    onBeforeMount(() => {
      if (regions.value) {
        searchParams.company = user.value?.company
        searchParams.region = regions.value
      }
    })

    onMounted(() => {
      setTimeout(() => {
        Object.assign(searchParams, selectedCompany.value)
      }, 1000)
    })

    watch(
      regions,
      () => {
        if (
          localStorage.getItem('company')?.length === 0 &&
          localStorage.getItem('region')?.length === 0
        ) {
          searchParams.company = user.value?.company || companies[0].value
          searchParams.region = regions.value[0]?.value || ''
          store.commit('division/SELECT_COMPANY', searchParams)
        }
      },
      {
        deep: true,
      },
    )

    return {
      regions,
      transform,
      searchParams,
      selectCompany,
    }
  },
})
</script>
